module.exports = require('./lib/browser/Parse.js');



//////////////////
// WEBPACK FOOTER
// ./~/parse/index.js
// module id = 1330
// module chunks = 0